import React, { useState, useEffect } from "react";
import { Card, Typography, Input, Button, Select } from "antd";
import { motion } from "framer-motion";
import axios from "axios";
import registerImg from "../assets/yoga5.jpg";
import { BASE_URL } from "../Config";
import { isValidPhoneNumber } from "libphonenumber-js";

import SuccessPopup from "../Components/popup/SuccessPopup";
import ErrorPopup from "../Components/popup/ErrorPopup";
import countries from "world-countries";
import { useNavigate } from "react-router-dom";

const { Title, Text } = Typography;

const Register = () => {
  const [isMobile, setIsMobile] = useState(false);

  const [successPopup, setSuccessPopup] = useState(false);
  const [errorPopup, setErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    mobileNumber: "",
    country: undefined, // ✅ IMPORTANT
  });

  const countryOptions = countries
    .map((c) => ({
      label: `${c.name.common} (+${c.idd.root?.replace("+", "") || ""}${c.idd.suffixes?.[0] || ""
        })`,
      value: c.cca2, // country code like IN, US
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

  const validatePhone = (phone, country) => {
    try {
      return isValidPhoneNumber(phone, country);
    } catch {
      return false;
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleRegister = async () => {
    if (!formData.mobileNumber) {
      setErrorMessage("Mobile number is required");
      setErrorPopup(true);
      return;
    }

    if (!validatePhone(formData.mobileNumber, formData.country)) {
      setErrorMessage("Enter valid phone number");
      setErrorPopup(true);
      return;
    }

    try {
      const res = await axios.post(`${BASE_URL}/users`, formData);
      setSuccessPopup(true);
      setFormData({
        name: "",
        email: "",
        password: "",
        mobileNumber: "",
        country: "",
      });
      navigate("/login");
    } catch (err) {
      const msg =
        err.response?.data?.message || "Registration failed. Try again.";
      setErrorMessage(msg);
      setErrorPopup(true);
    }
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      style={{
        backgroundColor: "#62bf6bff",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: isMobile ? "80px 10px 20px" : "20px",
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        style={{
          backgroundColor: "#fff",
          width: isMobile ? "100%" : "900px",
          maxWidth: "900px",
          height: isMobile ? "auto" : "500px",
          borderRadius: "15px",
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          boxShadow: "0 5px 20px rgba(0,0,0,0.25)",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            flex: 1,
            backgroundColor: "#fff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRight: isMobile ? "none" : "1px solid #f0f0f0",
            padding: isMobile ? "20px 0" : "0",
          }}
        >
          <img
            src={registerImg}
            alt="Register"
            style={{
              width: isMobile ? "90%" : "80%",
              height: "auto",
            }}
          />
        </div>

        <div
          style={{
            flex: 1,
            padding: isMobile ? "25px" : "30px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Title level={2}>Create Account</Title>
          <Text style={{ marginBottom: 20 }}>
            Register to start your wellness journey
          </Text>

          <Input
            name="name"
            placeholder="Enter your Full Name"
            value={formData.name}
            onChange={handleChange}
            style={{ marginBottom: 20, height: 40 }}
          />

          <Input
            name="email"
            type="email"
            placeholder="Enter your Email"
            value={formData.email}
            onChange={handleChange}
            style={{ marginBottom: 20, height: 40 }}
          />

          <Input.Password
            name="password"
            placeholder="Enter your Password"
            value={formData.password}
            onChange={handleChange}
            style={{ marginBottom: 20, height: 40 }}
          />

          <Input
            name="mobileNumber"
            placeholder="Enter your Mobile Number"
            value={formData.mobileNumber}
            onChange={handleChange}
            style={{ marginBottom: 20, height: 40 }}
          />
          <Select
            showSearch
            placeholder="Enter your Country"
            value={formData.country}
            options={countryOptions}
            optionFilterProp="label"
            onChange={(value) => setFormData({ ...formData, country: value })}
            style={{ width: "100%", marginBottom: 20 }}
          />

          <Button
            type="primary"
            onClick={handleRegister}
            style={{
              width: "100%",
              height: 45,
              backgroundColor: "#62bf6bff",
              borderRadius: "8px",
              fontSize: "16px",
            }}
          >
            REGISTER
          </Button>

          <Text style={{ marginTop: 15 }}>
            Already have an account?{" "}
            <a href="/login" style={{ fontWeight: "bold" }}>
              Login
            </a>
          </Text>
        </div>
      </motion.div>

      <SuccessPopup
        open={successPopup}
        onClose={() => setSuccessPopup(false)}
        message="Registered Successfully!"
      />

      <ErrorPopup
        open={errorPopup}
        onClose={() => setErrorPopup(false)}
        message={errorMessage}
      />
    </div>
  );
};

export default Register;
